import React, { createContext, useContext, useMemo, type ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const RoleContext = createContext<RoleContextValue | null>(null);

interface RoleProviderProps {
	children: ReactNode;
}

interface RoleContextValue {
	isAdmin: boolean;
	isUser: boolean;
	isSupplier: boolean;
	roles: string[];
	isLoading: boolean;
}

export const RoleProvider = ({ children }: RoleProviderProps) => {
	const { user, isLoading } = useAuth0();

	const value = useMemo<RoleContextValue>(() => {
		const roles = user?.user_roles || [];
		return {
			isAdmin: roles.includes('ADMIN'),
			isUser: roles.includes('USER'),
			isSupplier: roles.includes('SUPPLIER'),
			roles,
			isLoading,
		};
	}, [user, isLoading]);

	return <RoleContext.Provider value={value}>{children}</RoleContext.Provider>;
};

export const useRole = () => {
	const context = useContext(RoleContext);
	if (!context) {
		throw new Error('useRole must be used within an RoleProvider');
	}
	return context;
};
